import BackofficeServicesRepository from '@/_shared/repositories/backoffice-services.repository';
import OmegaRepository from '@/_shared/repositories/omega.respository';
import AdvancementParams from '@/achieve/interfaces/advancement-params.interface';
import RankAdvancementEntity from '@/achieve/entities/rank-advancement/rank-advancement.entity';
import CountryRankAdvancement from '@/achieve/entities/rank-advancement/country-rank-advancement.entity';
import RankAdvancementLocation from '@/achieve/entities/rank-advancement/rank-advancement-location.entity';

class RankAdvancementService {
  private servicesRepository: BackofficeServicesRepository = new BackofficeServicesRepository();
  private omegaRepository: OmegaRepository = new OmegaRepository();

  public getAdvancement(params: AdvancementParams): Promise<RankAdvancementEntity> {
    const { regionId, rankId, month, page } = params;
    return this.servicesRepository.get(`/distributors/clubs/rankadvancement/${regionId}/${rankId}/${month}/${page}`, {
      withCredentials: true,
    })
      .then(({ data }) => new RankAdvancementEntity(data));
  }

  public getHighestRankAdvancements(start: string, end: string): Promise<CountryRankAdvancement[]> {
    return this.omegaRepository.get('/bo/rank/advancement', {
      withCredentials: true,
      params: { start: `'${start}'`, end: `'${end}'` },
    })
      .then(({ data }) => (data.highestRankAdvancements || [])
        .map((item: any) => new CountryRankAdvancement(item)));
  }

  public getLocations(): Promise<RankAdvancementLocation> {
    return this.servicesRepository.get('/distributors/clubs/countries', { withCredentials: true })
      .then(({ data }) => new RankAdvancementLocation(data));
  }
}

export default new RankAdvancementService();
